<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title mode="ios">
      <div class="header-logo">&nbsp;</div>
    </ion-title>
    <ion-buttons slot="end" [ngClass]="fromLogin">
      <ion-button (click)="showMenu()" class="menu" [attr.aria-label]="(newBadgeCount + newContentCount > 0 ? 'ARIA.MENU.BUTTON.LABEL_N' : 'ARIA.MENU.BUTTON.LABEL_0') | translate : {cnt: newBadgeCount + newContentCount}">
        <ion-badge *ngIf="newBadgeCount + newContentCount > 0" class="badge" aria-hidden="true">{{ newBadgeCount + newContentCount }}</ion-badge>
        <ion-icon slot="icon-only" aria-hidden="true"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content no-bounce [ngClass]="'no-scroll ion-padding dashboard '+fromLogin" (window:resize)="onResize()">
@if(mode == 'standard') {
  <ion-searchbar *ngIf="fromLogin == ''" show-clear-button="focus" [debounce]="1000" (ionInput)="handleSearchInput($event)" [placeholder]="'SEARCH.PLACEHOLDER' | translate" (click)="checkSeachInput()" (focus)="checkSeachInput()"></ion-searchbar>
  <div class="ring-container" #ringContainer>
    <div class="ring">
      <svg #svg viewBox="0 0 100 100" [ngClass]="ringSvgClass">
  
        <foreignObject class="logoBack"  x="0" y="0" width="100" height="100">
          <div class="logoGradient" xmlns="http://www.w3.org/1999/xhtml"></div>
        </foreignObject>
  
        <g class="logoBlend">
            <rect x="0" y="0" width="100" height="100" />
            <path d="M 50 98 a 48 48 0 0 1 0 -96 48 48 0 0 1 0 96" />
            <polygon points="48,98 50,88 52,98" />
        </g>
      </svg>
      <div class="login-info" id="login-info1">
        <div class="main" translate>MENU.TODAY.NAME</div>
      </div>
      <div class="login-info" id="login-info2">
        <div class="main" translate>MENU.COREFACTS.NAME</div>
      </div>
      <div class="login-info" id="login-info3">
        <div class="main" translate>MENU.PERSONAL.NAME</div>
      </div>
      <div class="login-info" id="login-info4">
        <div class="main" translate>MENU.KNOWHOW.NAME</div>
      </div>
      <div [ngClass]="'pane-container dot'+dotNr">
        <div class="dotPane dotPane0" (click)="onDot(1)">
        </div>
        <div #pane class="pane">
          <div class="info" style="left: 0">
            <info-pane [ngClass]="infoClass[0]" [info]="infoData[0]" (dialogClicked)="showDialog($event)" (thesisClicked)="doneThesis($event, 0)" (textClicked)="onTextClicked()"></info-pane>
          </div>
          <div class="info" style="left: 10%">
            <info-pane [ngClass]="infoClass[1]" [info]="infoData[1]" (dialogClicked)="showDialog($event)" (thesisClicked)="doneThesis($event, 1)"></info-pane>
          </div>
          <div class="info" style="left: 20%">
            <info-pane [ngClass]="infoClass[2]" [info]="infoData[2]" (dialogClicked)="showDialog($event)" (thesisClicked)="doneThesis($event, 2)"></info-pane>
          </div>
          <div class="info" style="left: 30%">
            <info-pane [ngClass]="infoClass[3]" [info]="infoData[3]" (dialogClicked)="showDialog($event)" (thesisClicked)="doneThesis($event, 3)"></info-pane>
          </div>
          <div class="info" style="left: 40%">
            <info-pane [ngClass]="infoClass[4]" [info]="infoData[4]" (dialogClicked)="showDialog($event)" (thesisClicked)="doneThesis($event, 4)"></info-pane>
          </div>
          <div class="info" style="left: 50%">
            <info-pane [ngClass]="infoClass[5]" [info]="infoData[5]" (dialogClicked)="showDialog($event)" (thesisClicked)="doneThesis($event, 5)"></info-pane>
          </div>
          <div class="info" style="left: 60%">
            <info-pane [ngClass]="infoClass[6]" [info]="infoData[6]" (dialogClicked)="showDialog($event)" (thesisClicked)="doneThesis($event, 6)"></info-pane>
          </div>
          <div class="info" style="left: 70%">
            <info-pane [ngClass]="infoClass[7]" [info]="infoData[7]" (dialogClicked)="showDialog($event)" (thesisClicked)="doneThesis($event, 7)"></info-pane>
          </div>
          <div class="info" style="left: 80%">
            <info-pane [ngClass]="infoClass[8]" [info]="infoData[8]" (dialogClicked)="showDialog($event)" (thesisClicked)="doneThesis($event, 8)"></info-pane>
          </div>
          <div class="info" style="left: 90%">
            <info-pane [ngClass]="infoClass[9]" [info]="infoData[9]" (dialogClicked)="showDialog($event)" (thesisClicked)="doneThesis($event, 9)"></info-pane>
          </div>
        </div>
        <div class="dotPane dotPane2" (click)="showPage('menu/corefacts')">
          <div class="main" translate>MENU.COREFACTS.NAME</div>
            </div>
        <div class="dotPane dotPane3" (click)="showPage('menu/personal')">
          <div class="main" translate>MENU.PERSONAL.NAME</div>
            </div>
        <div class="dotPane dotPane4" (click)="showPage('menu/knowhow')">
          <div class="main" translate>MENU.KNOWHOW.NAME</div>
        </div>
        <div class="cover">
        </div>
      </div>
      <div [ngClass]="'dot1-topper dot'+dotNr">
        <div translate>MENU.TODAY.NAME</div>
      </div>
      <svg #wedge viewBox="0 0 100 100" [ngClass]="ringSvgClass" id="wedge">
        <g class="logoBlend">
            <polygon points="48,98 50,88 52,98" />
        </g>
      </svg>

    </div>
    <div [ngClass]="getDotButtonClass(1)" id="dot1" (click)="onDot(1)"><div class="dot"></div></div>
    <div [ngClass]="getDotButtonClass(2)" id="dot2" (click)="onDot(2)"><div class="dot"></div></div>
    <div [ngClass]="getDotButtonClass(3)" id="dot3" (click)="onDot(3)"><div class="dot"></div></div>
    <div [ngClass]="getDotButtonClass(4)" id="dot4" (click)="onDot(4)"><div class="dot"></div></div>
    <div [ngClass]="'pane-desk-arrow pane-desk-arrow-left at-dot'+dotNr" (click)="moveCarousel(-1)">
      <button>
        <ion-icon name="chevron-back-outline"></ion-icon>
      </button>
    </div>
    <div [ngClass]="'pane-desk-arrow pane-desk-arrow-right at-dot'+dotNr" (click)="moveCarousel(1)">
      <button>
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </button>
    </div> 
  </div>
  <instruction key="dashboard" *ngIf="fromLogin == ''">{{'INSTRUCTION.DASHBOARD' | translate}}</instruction>
}
@if(mode == 'simple') {
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <ion-button class="simple-button" fill="clear" expand="full" (click)="onSimpleDiaClick()">
          <div class="custom-button-content">
            <ion-icon name="chatbox-outline" aria-hidden="true"></ion-icon>
            <ion-label>{{firstDiaTitle()}}</ion-label>
          </div>
        </ion-button>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="6">
        <ion-button class="simple-button" fill="clear" expand="full" (click)="onSimpleContentsClick()">
          <div class="custom-button-content">
            <ion-icon name="library-outline" aria-hidden="true"></ion-icon>
            <ion-label translate>MENU.KNOWHOW.CONTENTS</ion-label>
          </div>
        </ion-button>
      </ion-col>
      <ion-col size="6">
        <ion-button class="simple-button" fill="clear" expand="full" (click)="onSimpleSettingsClick()">
          <div class="custom-button-content">
            <ion-icon name="settings-outline" aria-hidden="true"></ion-icon>
            <ion-label translate>PROFILE.SETTINGS</ion-label>
          </div>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
}

</ion-content>

@if(mode == 'standard') {
<ion-footer [ngClass]="'dashboard '+fromLogin">
  <div [ngClass]="(dotNr == 1 && lowerPanelMapping[1].length > 0 ? 'show' : (oldDotNr == 1 && lowerPanelMapping[1].length > 0 ? ' hide' : '')) + ' lower-panel'"  *ngIf="(dotNr == 1 || oldDotNr == 1) && lowerPanelMapping[1].length > 0">
      <swiper id="sw_today" class="lower-slides" [initialSlide]="1" [slidesPerView]="1" [spaceBetween]="20" [centeredSlides]="true" [loop]="true"
      [preventClicks]="false" [preventClicksPropagation]="false"
      [navigation]="lowerPanelMapping[1].length > 1" pagination="true"
      (slideChange) = "checkMoveDialog($event)"
      #swiper_today>
      <ng-template ngFor let-userContent [ngForOf]="lowerPanelMapping[1]">
        <ng-template swiperSlide>
          <two-pane-cont [userContent]="userContent"
            (interactionClicked)="showContent(userContent)"></two-pane-cont>
        </ng-template>
      </ng-template>
    </swiper>
  </div>
  <div [ngClass]="(dotNr == 3 ? 'show' : (oldDotNr == 3 ? ' hide' : '')) + ' lower-panel'" *ngIf="dotNr == 3 || oldDotNr == 3">
    <three-pane-3 id="monitoring" title="{{'MENU.PERSONAL.MONITORING' | translate}}" *ngIf="showLowerPanel('monitoring')"
    [data]="monitoringData" label="{{'MONITORING.LEVEL.NAME' | translate}}" [text]="levelName"
    (interactionClicked)="showPage('menu/personal')"></three-pane-3>
  </div>

  <!--div [ngClass]="(dotNr == 3 ? 'show' : (oldDotNr == 3 ? ' hide' : '')) + ' lower-panel'" *ngIf="dotNr == 3 || oldDotNr == 4">
    <swiper id="sw_personal" class="lower-slides" [initialSlide]="1" [slidesPerView]="1" [spaceBetween]="20" [centeredSlides]="true"
    [loop]="true" 
    [preventClicks]="false" [preventClicksPropagation]="false"
    navigation="true" pagination="true"      
    #swiper_personal>
      <ng-template swiperSlide [ngIf]="showLowerPanel('mindset')">
        <theses-pane-2 id="themes" title="{{'THESES.MINDSET' | translate}}" *ngIf="showLowerPanel('mindset')"
        [data]="thesesStat['mindset']"
        (interactionClicked)="showPage('mindset')"></theses-pane-2>
      </ng-template>
      <ng-template swiperSlide [ngIf]="showLowerPanel('efficacy')">
        <theses-pane-2 id="themes" title="{{'THESES.EFFICACY' | translate}}" *ngIf="showLowerPanel('efficacy')"
        [data]="thesesStat['efficacy']"
        (interactionClicked)="showPage('efficacy')"></theses-pane-2>
      </ng-template>
      <ng-template swiperSlide [ngIf]="showLowerPanel('performance')">
        <theses-pane-2 id="themes" title="{{'THESES.PERFORMANCE' | translate}}" *ngIf="showLowerPanel('performance')"
        [data]="thesesStat['performance']"
        (interactionClicked)="showPage('performance')"></theses-pane-2>
      </ng-template>
    </swiper>
  </div-->
  <div [ngClass]="(dotNr == 4 ? 'show' : (oldDotNr == 4 ? ' hide' : '')) + ' lower-panel'" *ngIf="dotNr == 4 || oldDotNr == 4">
    <swiper id="sw_knowhow" class="lower-slides" [initialSlide]="1" [slidesPerView]="1" [spaceBetween]="20" [centeredSlides]="true" [loop]="true" 
    [preventClicks]="false" [preventClicksPropagation]="false"
    navigation="true" pagination="true"      
    #swiper_knowhow>
      <ng-template swiperSlide [ngIf]="showLowerPanel('themes')">
        <three-pane-3 id="themes" title="{{'CONTENT.TITLE' | translate}}" *ngIf="showLowerPanel('themes')"
        [data]="themesData" label="{{'LP.DONE_IN_PERCENT' | translate}}"
        (interactionClicked)="showPage('content')"></three-pane-3>
      </ng-template>
      <ng-template swiperSlide [ngIf]="showLowerPanel('podcasts')">
        <three-pane-3 id="podcasts" title="{{'MENU.KNOWHOW.PODCASTS' | translate}}" *ngIf="showLowerPanel('podcasts')"
        [data]="podcastsData" label="{{'LP.DONE_IN_PERCENT' | translate}}"
        (interactionClicked)="showPodcastPage()"></three-pane-3>
      </ng-template>
      <ng-template swiperSlide [ngIf]="showLowerPanel('videos')">
        <three-pane-3 id="videos" title="{{'MENU.KNOWHOW.VIDEOS' | translate}}" *ngIf="showLowerPanel('videos')"
        [data]="videosData" label="{{'LP.DONE_IN_PERCENT' | translate}}"
        (interactionClicked)="showPage('knowledge/video')"></three-pane-3>
      </ng-template>
      <ng-template swiperSlide [ngIf]="showLowerPanel('tips')">
        <three-pane-3 id="tips" title="{{'TIPS.TITLE' | translate}}" *ngIf="showLowerPanel('tips')"
        [data]="tipsData" label="{{'LP.DONE_IN_PERCENT' | translate}}"
        (interactionClicked)="showTipsPage()"></three-pane-3>
      </ng-template>
    </swiper>
  </div>
</ion-footer>
}
